import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'readMore',
  standalone: true
})
export class ReadMorePipe implements PipeTransform {
  transform(
    value: string,
    limit: number
  ): { text: string; showReadMore: boolean } {
    if (!value) return { text: '', showReadMore: false }

    const showReadMore = value.length > limit
    let finalText = value

    if (showReadMore) {
      const trimmedText = value.substring(0, limit)
      const lastSpaceIndex = trimmedText.lastIndexOf(' ')

      finalText =
        lastSpaceIndex !== -1
          ? trimmedText.substring(0, lastSpaceIndex)
          : trimmedText
      finalText += '...'
    }

    return { text: finalText, showReadMore }
  }
}
